module.exports = __webpack_public_path__ + "img/learner.9cab8451.webp";